
import _once from "lodash/once"
import Promise from "plugins/bluebird"
import L from "plugins/leaflet/index"
import URI from "urijs"

import AssetsInfoStore from "app/assets_info_store"
import DataRetriever from "app/data_retriever"

import GoogleMapsTileLayer from "app/map/city_map/layers/google_maps_tile_layer"

import {
  asyncLoad as Baidu_asyncLoad,
} from "app/baidu-maps"


import I18n from "plugins/i18n-js"


interface FullGoogleMapsOptions {
  streetViewControl: boolean,
  styles: boolean,
}
interface PartialGoogleMapsOptions {
  streetViewControl?: boolean,
  styles?: object,
}

const get_force_google_cn = _once(() => {
  return URI(window.location.href).search().indexOf("force_map_tile=google_cn") !== -1
})
const get_display_baidu_maps = _once(() => {
  return !get_force_google_cn() && DataRetriever.get("display-baidu-maps")
})

const isUserInChina = () => {
  return typeof DataRetriever.get("current-location-country-code-is-china") !== "undefined"
}

interface LeafletGoogleLogoOptions extends L.ControlOptions {
  url: string,
}
class LeafletGoogleLogoControl extends L.Control {
  constructor(options?: LeafletGoogleLogoOptions) {
    super(options)
  }
}
const L_Google_Logo = L.Control.extend({
  options: {
    position: "bottomleft",
  },

  onAdd: function() {
    const img: HTMLImageElement = (L.DomUtil.create("img") as HTMLImageElement)

    img.src = this.options.url
    img.classList.add("l-google-maps-tile-layer-logo")

    return img
  },
}) as {new(...args: any[]): any} & typeof L.Control & typeof LeafletGoogleLogoControl


class LeafletGoogleMapsTileLayer extends L.TileLayer {
  public onAdd(map: L.Map) {
    AssetsInfoStore.fetch("logo/google_logo/colorful_with_outline_transparent_66_26.png")
    .then((logo_data) => {
      const logo = new L_Google_Logo({
        url: logo_data.url,
      })

      map.addControl(logo)
    })

    L.TileLayer.prototype.onAdd.call(this, map)
    return this
  }
}

class LeafletAutonaviTileLayer extends L.TileLayer {
  public onAdd(map: L.Map) {
    AssetsInfoStore.fetch("logo/autonavi_logo/white_with_outline_transparent.png")
    .then((logo_data) => {
      const logo = new L_Google_Logo({
        url: logo_data.url,
      })

      map.addControl(logo)
    })

    L.TileLayer.prototype.onAdd.call(this, map)
    return this
  }
}


const getNewTileLayerPromise = (): Promise<L.TileLayer> => {
  return new Promise((resolve, reject) => {
    try {
      let tile_layer
      if (get_display_baidu_maps()) {
        // This is against Google Maps ToS
        // But this change is authorized by Asif
        const tile_template_url = "http://{s}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}"

        tile_layer = new LeafletAutonaviTileLayer(tile_template_url, {
          subdomains:    ["webrd01", "webrd02", "webrd03", "webrd04"],
          maxNativeZoom: 22,
          // Still not sure what attribution should be used
          // attribution: "",
        })

        GoogleMapsTileLayer.setLayer(tile_layer)
        resolve(tile_layer)
      }
      else {
        // This is against Google Maps ToS
        // But this change is authorized by Asif
        const tile_template_url = `${window.location.protocol}//{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&hl=${I18n.locale}`

        // https://stackoverflow.com/questions/23017766/google-maps-tile-url-for-hybrid-maptype-tiles
        // `lyrs=m` = Standard Roadmap
        tile_layer = new LeafletGoogleMapsTileLayer(tile_template_url, {
          subdomains:    ["mt0", "mt1", "mt2", "mt3"],
          maxNativeZoom: 22,
          // Still not sure what attribution should be used
          // attribution: "",
        })

        GoogleMapsTileLayer.setLayer(tile_layer)
        resolve(tile_layer)
      }
    }
    catch (error) {
      reject(error)
    }
  })
}

const LeafletMapTileLayer = {
  getNewTileLayerPromise,
}

export {
  LeafletMapTileLayer,
}

export default LeafletMapTileLayer
